import Vue from 'vue';
import store from '../../store';
import contactTypeTransformer from '../../transformers/contactType';

const success = ({ data }, resolve) => {
  const contactTypes = contactTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchcontactTypes', contactTypes);
  resolve();
};

const failed = () => {
};

// Display clientContact types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('contact_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/contactType/all.js